// Statistiek kaart met value + label, solid card border
import { Typography, Paper } from '@mui/material';
import { buildStatBlockSx } from '@/components/ui/statBlockSx';

const DENSE_VALUE_FONT_SIZE = 13;
const NORMAL_VALUE_FONT_SIZE = 26;

/** StatBlock — statistiek kaart met value + label */
export function StatBlock({
  value,
  label,
  dense = false,
  children,
  onClick,
  sx,
  ...paperProps
}) {
  return (
    <Paper
      component={onClick ? 'button' : 'div'}
      type={onClick ? 'button' : undefined}
      variant="outlined"
      onClick={onClick}
      {...paperProps}
      sx={buildStatBlockSx({ onClick, sx })}
    >
      {children}
      {value ? (
        <Typography
          component="div"
          sx={{
            fontSize: dense ? DENSE_VALUE_FONT_SIZE : NORMAL_VALUE_FONT_SIZE,
            fontWeight: 700,
          }}
        >
          {value}
        </Typography>
      ) : null}
      {label ? (
        <Typography
          variant="caption"
          color={dense ? 'text.secondary' : 'text.subtle'}
        >
          {label}
        </Typography>
      ) : null}
    </Paper>
  );
}
